
import { authStore } from './authStore';

const API_URL = '/api/invoicing/rules';

const InvoiceRuleService = {
    getRules: async (countryCode) => {
        try {
            const token = authStore.getAccessToken();
            // console.log("InvoiceRuleService: Fetching rules for", countryCode, "Token Present:", !!token);
            const response = await fetch(`${API_URL}/${countryCode}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                // Fallback or error handling
                console.warn(`Could not load rules for country ${countryCode}`);
                return null;
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching invoice rules:', error);
            return null;
        }
    }
};

export default InvoiceRuleService;
